/** Perspectivas da consulta da Curva ABC de Vendas */
export interface CurvaAbcVendaPerspectiva {
    id: number;
    nome: string;
    isShowCodigoIntegracaoErp?: boolean;
}

export const perspectivaItem: CurvaAbcVendaPerspectiva = {
    id: 1,
    nome: 'Itens',
    isShowCodigoIntegracaoErp: true,
};
export const perspectivaSegmentoItem: CurvaAbcVendaPerspectiva = {
    id: 2,
    nome: 'Segmentos de Itens'
};
export const perspectivaCliente: CurvaAbcVendaPerspectiva = {
    id: 3,
    nome: 'Clientes',
    isShowCodigoIntegracaoErp: true
};
export const perspectivaSegmentoCliente: CurvaAbcVendaPerspectiva = {
    id: 4,
    nome: 'Segmentos de Clientes'
};
export const perspectivaRepresentante: CurvaAbcVendaPerspectiva = {
    id: 5,
    nome: 'Representantes',
    isShowCodigoIntegracaoErp: true
};
export const perspectivaEstado: CurvaAbcVendaPerspectiva = {
    id: 6,
    nome: 'Estados'
};
export const perspectivaGrupoRentabilidade: CurvaAbcVendaPerspectiva = {
    id: 7,
    nome: 'Grupos de Rentabilidades'
};

export function getPerspectivas(isRepresentante = false): CurvaAbcVendaPerspectiva[] {
    const perspectivas: CurvaAbcVendaPerspectiva[] = [];
    perspectivas.push(perspectivaItem);
    perspectivas.push(perspectivaSegmentoItem);
    perspectivas.push(perspectivaGrupoRentabilidade);
    perspectivas.push(perspectivaCliente);
    perspectivas.push(perspectivaSegmentoCliente);
    if (!isRepresentante) {
        perspectivas.push(perspectivaRepresentante);
    }
    perspectivas.push(perspectivaEstado);

    return perspectivas;
}

/** Verifica se a perspectiva é por item  */
export function isPerspectivaItem(perspectiva: number): boolean {
    return perspectiva === perspectivaItem.id;
}

/** Verifica se a perspectiva é por segmentos de itens  */
export function isPerspectivaSegmentoItem(perspectiva: number): boolean {
    return perspectiva === perspectivaSegmentoItem.id;
}

/** Verifica se a perspectiva é por cliente  */
export function isPerspectivaCliente(perspectiva: number): boolean {
    return perspectiva === perspectivaCliente.id;
}

/** Verifica se a perspectiva é por segmentos de clientes  */
export function isPerspectivaSegmentoCliente(perspectiva: number): boolean {
    return perspectiva === perspectivaSegmentoCliente.id;
}

/** Verifica se a perspectiva é por representante  */
export function isPerspectivaRepresentante(perspectiva: number): boolean {
    return perspectiva === perspectivaRepresentante.id;
}

/** Verifica se a perspectiva é por estado  */
export function isPerspectivaEstado(perspectiva: number): boolean {
    return perspectiva === perspectivaEstado.id;
}

/** Verifica se a perspectiva é por grupo de rentabilidade  */
export function isPerspectivaGrupoRentabilidade(perspectiva: number): boolean {
    return perspectiva === perspectivaGrupoRentabilidade.id;
}
